import {
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  LOGOUT_DETAILS_SUCCESS,
} from "../actionTypes";
import { loginApi } from "../../../API/ApiService";
import { loadingAction } from "../loadingAction";
import { addBusinessDetail } from "../BusinessAction/businesAction";
import { deleteCookie } from '../../../Utils/cookieUtils';

export const login = (data) => {
  return (dispatch) => {
    dispatch(loadingAction(true));
    return loginApi(data)
      .then((response) => {
        dispatch(loadingAction(false));
        dispatch({ type: LOGOUT_DETAILS_SUCCESS, payload: {} })
        const userData = response.data.user
        if (userData.status != 0) {
          dispatch({ type: LOGIN_SUCCESS, payload: { ...response, data: { ...response.data, result: response.data.user } } });
        }
        return response
      })
      .catch((err) => {
        dispatch(loadingAction(false));
        throw err;
      });
  };
};

export const logout = () => {
  return (dispatch) => {
    // dispatch(loadingAction(true));
    // localStorage.clear();
    // localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("id");
    localStorage.removeItem("user");
    localStorage.removeItem("user_uuid");
    localStorage.removeItem("businessName");
    localStorage.removeItem("totalUnreadCount");
    // localStorage.removeItem("sign_in_type");
    // Remove the token cookie
    deleteCookie('token');
    dispatch({ type: LOGOUT_SUCCESS, payload: "LOGOUT" });
    dispatch({ type: 'RESET_BUSINESS_DETAILS_SUCCESS' })
    return dispatch({ type: LOGOUT_DETAILS_SUCCESS, payload: "LOGOUT" });
  };
};
